export default __webpack_public_path__ + "static/media/gas91.b8ff60c8.svg";